import { useQuery } from "@tanstack/react-query";
import { AIAgentDefinitions } from "@graylog/enterprise-api";
import { WORKFLOW_DEFINITIONS_QUERY_KEY } from "../Constants";
const fetchWorkflowPrompt = (id) => AIAgentDefinitions.getPrompt(id).then(({ prompt }) => prompt);
const useWorkflowPrompt = (id) => useQuery({
  queryKey: [...WORKFLOW_DEFINITIONS_QUERY_KEY, "prompt", id],
  queryFn: () => fetchWorkflowPrompt(id),
  enabled: Boolean(id),
  staleTime: 6e4
});
export default useWorkflowPrompt;
